module.exports = __webpack_public_path__ + "h5/img/bojin_footer.be14e0e3.png";